import { z } from 'zod'
import { ref, siteId } from '@omnea-app/packages/universal/references/refKinds'
import { RfxTriggerComparisonSchema } from '../conditionality/rfxTriggerCondition'

export const SubWorkflowAttachmentSchema = z.object({
  // Only the builder keeps attachments unique: its picker offers only sub-workflows the block hasn't attached, so the
  // sub-workflow's id names its trigger within the block.
  subWorkflowId: siteId(ref('subWorkflow'), 'subWorkflowTrigger'),
  manualAllowed: z.boolean(),
  condition: RfxTriggerComparisonSchema.optional(),
})

export type SubWorkflowAttachment = z.infer<typeof SubWorkflowAttachmentSchema>

type AttachmentPayload = { subWorkflowIds?: string[]; subWorkflows?: SubWorkflowAttachment[] }

export const subWorkflowAttachmentKeys = ['subWorkflowIds', 'subWorkflows'] as const satisfies (keyof AttachmentPayload)[]

// Stored configs and frozen request models carry the bare id list and are never rewritten, so a bare
// id has to keep meaning what it always meant: owners may start it by hand, nothing starts it itself.
export const normaliseSubWorkflowAttachments = (payload: AttachmentPayload): SubWorkflowAttachment[] =>
  payload.subWorkflows ?? (payload.subWorkflowIds ?? []).map((subWorkflowId) => ({ subWorkflowId, manualAllowed: true }))

export const toSubWorkflowIds = (subWorkflowAttachments: SubWorkflowAttachment[]): string[] =>
  subWorkflowAttachments.map((attachment) => attachment.subWorkflowId)
